import { rest } from 'app/rest'
import { api } from 'store/api'
import { me } from 'store/me'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { AvatarType } from 'type/Avatar'
import { EventName } from 'type/Event'
import { IdentityMode } from 'type/Identity'

type s = string | undefined
type n = number | undefined

class StatController {
  open(item_id: s, collection_id: s) {
    this.send('open_widget', item_id, { collection_id })
  }

  gen(
    item_id: s, collection_id: s, identity_id: s, inference_id: s, identity_mode: IdentityMode,
    combo_item_id: s, source_inference_id: s, combo_cart: boolean,
  ) {
    const name = source_inference_id ? 'start_video' : 'start_generation'
    const data: Record<string, unknown> = {
      collection_id, identity_id, inference_id, identity_mode,
      combo_item_id, source_inference_id,
    }
    if (combo_cart) data.combo_cart = combo_cart
    this.send(name, item_id, data)
  }

  view(item_id: s, collection_id: s, inference_id: s) {
    this.send('view_inference', item_id, { collection_id, inference_id })
  }

  share(item_id: s, collection_id: s, identity_id: s, inference_id: s, image_id: n, destination: s) {
    this.send('share_image', item_id, { collection_id, identity_id, inference_id, image_id, destination })
  }

  buy(item_id: s, collection_id: s, identity_id: s, inference_id: s, image_id: n) {
    this.send('click_buy', item_id, { collection_id, identity_id, inference_id, image_id })
  }

  /** клик по кнопке «С чем носить» на готовой генерации */
  recommendations(item_id: s, collection_id: s, inference_id: s) {
    this.send('click_recommendations', item_id, { collection_id, inference_id })
  }

  like(item_id: s, collection_id: s, identity_id: s, inference_id: s, image_id: n) {
    this.send('like', item_id, { collection_id, identity_id, inference_id, image_id })
  }

  dislike(item_id: s, collection_id: s, identity_id: s, inference_id: s, image_id: n) {
    this.send('dislike', item_id, { collection_id, identity_id, inference_id, image_id })
  }

  feedback(item_id: s, collection_id: s, identity_id: s, inference_id: s, image_id: n, code: n, reason: s) {
    this.send('feedback', item_id, { collection_id, identity_id, inference_id, image_id, code, reason })
  }

  setAvatar(avatar_type: AvatarType, available_options: string[]) {
    if (!opt.stand) return
    const object_id = store.profile.identity_id || 'new_profile'
    this.send('set_avatar', object_id, { avatar_type, available_options })
  }

  private send(name: EventName, object_id: s, data: Record<string, unknown>) {
    if (!object_id) throw new Error('no id')
    const user_id = me.user_id
    this.extend(data)
    void api.sendEvent({ name, user_id, object_id, data })
  }

  private extend(data: Record<string, unknown>) {
    Object.assign(data, {
      client: rest.client || undefined,
      company_id: rest.company || undefined,
      access_key: rest.access || undefined,
      origin: rest.origin || undefined,
      product_id: opt.options.product || undefined,
      test: opt.options.test || undefined,
      boutique: opt.boutique || undefined,
      manager_id: me.manager_id || undefined,
    })
  }
}

export const stat = new StatController()
